import { SystemEvent, SystemEventLevel } from './systemEvent.esm.js';

/* eslint-disable no-param-reassign */
var Utils = /** @class */ (function () {
    function Utils() {
    }
    Utils.init = function (clientLogger) {
        if (clientLogger && typeof clientLogger.getLoggerWithIdentifier === 'function') {
            var logger = clientLogger.getLoggerWithIdentifier('uitk-react-typeahead');
            if (logger && typeof logger.logEvent === 'function') {
                Utils.logger = logger;
            }
        }
    };
    Utils.isOrigin = function (domElementId) {
        domElementId = domElementId.toLowerCase();
        return (domElementId.indexOf('origin') > -1 ||
            domElementId.indexOf('from') > -1 ||
            domElementId.indexOf('departure') > -1 ||
            domElementId.indexOf('drop') > -1 ||
            domElementId.indexOf('home') > -1 ||
            domElementId.indexOf('loc2') > -1);
    };
    Utils.isDestination = function (domElementId) {
        domElementId = domElementId.toLowerCase();
        return (domElementId.indexOf('dest') > -1 ||
            domElementId.indexOf('to') > -1 ||
            domElementId.indexOf('arrival') > -1 ||
            domElementId.indexOf('near') > -1 ||
            domElementId.indexOf('pick') > -1 ||
            domElementId.indexOf('location') === 0);
    };
    Utils.getDomElement = function () {
        var _a;
        // Class name used in homepage and SRP typeahead component
        var element = (_a = document
            .querySelectorAll('.uitk-typeahead-dialog-layer-responsive .uitk-typeahead-dialog, .uitk-typeahead-menu-layer-responsive .uitk-typeahead-menu-container')[0]) === null || _a === void 0 ? void 0 : _a.getElementsByTagName('input')[0];
        if (!element) {
            Utils.logError({ message: 'Failed to retrieve data for the typeahead UI component' });
        }
        return element;
    };
    Utils.logError = function (error) {
        try {
            if (Utils.logger) {
                error = error.stack ? { message: error.message, stack: error.stack } : error;
                Utils.logger.logEvent(new SystemEvent(SystemEventLevel.ERROR, 'TypeaheadLoggingError'), error);
            }
        }
        catch (e) {
            /* istanbul ignore next */
            // tslint:disable-next-line:no-console
            console.error("unable to log errors from typeahead-client-logger. Reason:".concat(e));
        }
    };
    Utils.getInputElementId = function (inputEl) {
        var id;
        if (inputEl) {
            id = inputEl.getAttribute('data-stid');
            if (!id) {
                Utils.logError({ message: "Failed to retrieve input element id from 'data-stid'" });
            }
        }
        return id || Utils.UNKNOWN;
    };
    Utils.getSubLob = function (lob, sublob) {
        if (!sublob) {
            var usp = new URLSearchParams(window.location.search);
            sublob = usp.get('pwaSubLOB') || '';
        }
        switch (lob.toLowerCase()) {
            case 'flights':
                switch (sublob && sublob.toLowerCase()) {
                    case 'oneway':
                        return 'OW';
                    case 'multicity':
                        return 'MD';
                    default:
                        return 'RT';
                }
            case 'packages':
                switch (sublob && sublob.toLowerCase()) {
                    case 'fhc':
                        return 'FHC';
                    case 'hc':
                        return 'HC';
                    case 'fc':
                        return 'FC';
                    default:
                        return 'FH';
                }
            default:
                return '';
        }
    };
    Utils.UNKNOWN = 'UNKNOWN';
    return Utils;
}());

export { Utils };
